/* section-sec-sizing-fit-guide.js — tab sản phẩm + pill bảng (clone cơ chế click-driven Coterie sizing-101).
   JS chỉ set data-attr trên root + aria-selected; CSS attr-selector lo ẩn/hiện. */
(function () {
  'use strict';

  function initSizingFitGuide(root) {
    if (!root || root.dataset.sfgInit === '1') return;
    root.dataset.sfgInit = '1';

    root.addEventListener('click', function (e) {
      var tabBtn = e.target.closest('[data-sfg-tab]');
      if (tabBtn && root.contains(tabBtn)) {
        root.setAttribute('data-active-tab', tabBtn.getAttribute('data-sfg-tab'));
        root.querySelectorAll('[data-sfg-tab]').forEach(function (b) {
          b.setAttribute('aria-selected', b === tabBtn ? 'true' : 'false');
        });
        return;
      }

      var pillBtn = e.target.closest('[data-sfg-view]');
      if (pillBtn && root.contains(pillBtn)) {
        root.setAttribute('data-view', pillBtn.getAttribute('data-sfg-view'));
        root.querySelectorAll('[data-sfg-view]').forEach(function (b) {
          b.setAttribute('aria-selected', b === pillBtn ? 'true' : 'false');
        });
      }
    });
  }

  function initAll() {
    document.querySelectorAll('.sec-sizing-fit-guide').forEach(initSizingFitGuide);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme Editor: section re-render
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector && e.target.querySelector('.sec-sizing-fit-guide');
    if (root) initSizingFitGuide(root);
  });
})();
